import { ApiResponseModel } from '../types/ApiResponseModel';
import { DataRequestConfig } from '../types/DataRequestConfig';
import { NeglectedOrDelinquentContactModel } from '../types/NeglectedOrDelinquentContactModel';
import { NeglectedOrDelinquentInformationModel } from '../types/NeglectedOrDelinquentInformationModel';
import { OptionSetsPageModel } from '../types/OptionSetsPageModel';
import { SelectOption } from '../types/SelectOption';
import { getApiBaseUrl } from './app.service';
import { executeApiRequest, getAuthToken } from './base.service';
import { getHttpClient, HttpClient } from './httpClient';

export const neglectedOrDelinquentApiPaths = {
    contact: 'neglectedordelinquentcontact',
    schoolYears:
        'common/schoolyearsbymodule/formview/NeglectedOrDelinquent?showLongYears=true',
    information: (schoolYear: string) =>
        `neglectedordelinquentinformation/${encodeURIComponent(schoolYear)}`,
    createInformation: 'neglectedordelinquentinformation',
    inputOptionSets: 'common/optionsets/NeglectedOrDelinquent/InputPage',
};

const serviceClient = (config?: DataRequestConfig): HttpClient =>
    getHttpClient(getApiBaseUrl(), getAuthToken() || '', config?.signal);

export const getNeglectedOrDelinquentContact = (
    config?: DataRequestConfig
): Promise<ApiResponseModel<NeglectedOrDelinquentContactModel>> =>
    executeApiRequest(() =>
        serviceClient(config).get(neglectedOrDelinquentApiPaths.contact)
    );

export const postNeglectedOrDelinquentContact = (
    contact: NeglectedOrDelinquentContactModel,
    config?: DataRequestConfig
): Promise<ApiResponseModel<string>> =>
    executeApiRequest(() =>
        serviceClient(config).post(neglectedOrDelinquentApiPaths.contact, contact)
    );

export const putNeglectedOrDelinquentContact = (
    contact: NeglectedOrDelinquentContactModel,
    config?: DataRequestConfig
): Promise<ApiResponseModel<void>> =>
    executeApiRequest(() =>
        serviceClient(config).put(neglectedOrDelinquentApiPaths.contact, contact)
    );

export const getNeglectedOrDelinquentSchoolYears = (
    config?: DataRequestConfig
): Promise<ApiResponseModel<SelectOption[]>> =>
    executeApiRequest(() =>
        serviceClient(config).get(neglectedOrDelinquentApiPaths.schoolYears)
    );

export const getNeglectedOrDelinquentInformation = (
    schoolYear: string, config?: DataRequestConfig
): Promise<ApiResponseModel<NeglectedOrDelinquentInformationModel>> =>
    executeApiRequest(() =>
        serviceClient(config).get(neglectedOrDelinquentApiPaths.information(schoolYear))
    );

export const postNeglectedOrDelinquentInformation = (
    model: NeglectedOrDelinquentInformationModel, config?: DataRequestConfig
): Promise<ApiResponseModel<string>> =>
    executeApiRequest(() =>
        serviceClient(config).post(neglectedOrDelinquentApiPaths.createInformation, model)
    );

export const putNeglectedOrDelinquentInformation = (
    model: NeglectedOrDelinquentInformationModel, config?: DataRequestConfig
): Promise<ApiResponseModel<void>> =>
    executeApiRequest(() =>
        serviceClient(config).put(
            neglectedOrDelinquentApiPaths.information(String(model.schoolYear)), model
        )
    );

export const getNeglectedOrDelinquentInputOptionSets = (
    config?: DataRequestConfig
): Promise<ApiResponseModel<OptionSetsPageModel>> =>
    executeApiRequest(() =>
        serviceClient(config).get(neglectedOrDelinquentApiPaths.inputOptionSets)
    );
